'use client'

import { Palette } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { PopoverTrigger } from '@/components/ui/popover'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

export interface EditorColorPickerTriggerProps {
  currentColor?: string
  isDisabled: boolean
  className?: string
}

const triggerClasses = cn(
  'h-8 w-8 p-0',
  'hover:bg-accent hover:text-accent-foreground',
  'focus-visible:ring-1 focus-visible:ring-ring'
)

/**
 * Trigger button for the color picker popover
 */
export const EditorColorPickerTrigger = ({
  currentColor,
  isDisabled,
  className,
}: EditorColorPickerTriggerProps) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          disabled={isDisabled}
          className={cn(triggerClasses, className)}
          aria-label="Text Color"
        >
          <div className="flex flex-col items-center">
            <Palette className="size-4" />
            {currentColor && (
              <div
                className="mt-0.5 h-0.5 w-3 rounded-full"
                style={{ backgroundColor: currentColor }}
              />
            )}
          </div>
        </Button>
      </PopoverTrigger>
    </TooltipTrigger>
    <TooltipContent side="bottom" sideOffset={5}>
      <p>Text Color</p>
    </TooltipContent>
  </Tooltip>
)

EditorColorPickerTrigger.displayName = 'EditorColorPickerTrigger'
